import React from 'react'
import { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import MyButton from '../../../../UI/form/MyButton'
import WriteOffActDownload from './WriteOffActDownload'

const WriteOffActDownloadButton = ({ writeOffActId }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            Завантажити акт
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Завантажити акт для підписання'}
            disableClickOutside={true}
            content={
                <WriteOffActDownload
					writeOffActId={writeOffActId}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default WriteOffActDownloadButton